<!-- <div class="disable-cover" *ngIf="true" fxLayout="column" fxLayoutAlign="center center"> -->
<div class="disable-cover" *ngIf="isLoading$ | async" fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner color="accent" style="display: inline-block" diameter="64"></mat-spinner>
    <p class="loader-message">{{ message$ | async }}</p>
</div>
